import { StarVariant } from '../Star'

const getStarVariant = (value: number): StarVariant => {
  if (value <= 0) return StarVariant.EMPTY
  if (value > 0 && value < 0.3) return StarVariant.QUARTER
  if (value >= 0.3 && value < 0.7) return StarVariant.HALF
  if (value >= 0.7 && value < 1) return StarVariant.THREE_QUARTER
  return StarVariant.FILLED
}

export default getStarVariant
